/**
 * Vuex mutations for the "groupchannel" module.
 *
 * Synchronous state writers for the current group channel's data, the group
 * channel list, and the following list/count. Async work (API calls) lives
 * in operations.js, which commits these mutations with the results.
 */
export default {
  setGroupChannelData(state, data) {
    state.groupChannelData = data;
  },
  setGroupChannelsList(state, data) {
    state.groupChannelsList = data;
  },
  setFollowingList(state, data) {
    state.followingList = data;
  },
  /** Append one or more channels to `followingList`, skipping any whose `id` already exists (used for paginated loads). */
  addToFollowingList(state, data) {
    if (Array.isArray(data)) {
      data.forEach(item => {
        if (!state.followingList.some(existing => existing.id === item.id)) {
          state.followingList.push(item);
        }
      });
    } else if (data && !state.followingList.some(existing => existing.id === data.id)) {
      state.followingList.push(data);
    }
  },
  setFollowingCount(state, count) {
    state.followingCount = count;
  },
};
